import { compose, bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withFormik } from 'formik'
import { createStructuredSelector } from 'reselect'
import { push } from 'connected-react-router'
import { getApplyToStepPath } from '../../../MainRoutes/utils'
import { bindPromiseCreators } from '../../../../utils/routines'
import { selectApplyByParamsId } from '../../selectors'
import { createApplyStep } from '../../routines'
import definitions from './definitions'

// connector
const mapStateToProps = createStructuredSelector({
  application: selectApplyByParamsId
})
const mapDispatcToProps = dispatch => ({
  ...bindPromiseCreators({
    createStep: createApplyStep
  }, dispatch),
  ...bindActionCreators({
    redirect: push
  }, dispatch)
})
export const connector = connect(mapStateToProps, mapDispatcToProps)

//
const withFormikStep = ({
  step,
  ...options
} = {}) => {
  const {
    mapPropsToValues,
     validationSchema,
     mapValuesToData = v => v,
  } = definitions[step]

  const formik = withFormik({
    mapPropsToValues,
    validationSchema,
    async handleSubmit(values, { props, setStatus, setSubmitting }) {
      try {
        const id = props.application.id
        const data = validationSchema.cast(values)

        await props.createStep({
          id,
          step,
          data: mapValuesToData(data)
        })

        return props.redirect(getApplyToStepPath(step + 1, props.application))
      } catch (error) {
        console.error(error)
        setStatus({ error })
      } finally {
        setSubmitting(false)
      }
    },
    ...options
  })

  return compose(
    connector,
    formik
  )
}

export default withFormikStep
